import { createElement } from 'react';
import { createVoidSchemaComponent } from '../../shared';
const Container = (props) => {
    return createElement("div", Object.assign({}, props), props.children);
};
const FormilyContainer = createVoidSchemaComponent({
    componentName: 'Container',
    component: Container,
});
export default FormilyContainer;
